import { Link } from 'react-router-dom'
import { Layout } from '../Layout/Layout'

const RepairReplacementForm = () => {
  return (
    <Layout>
      <div className="container-xl p-0 d-none d-lg-block">
        <div className="row">
          <div className="col-md-6 col-sm-12 py-3 mx-2">
            <div className="d-block mb-3 mb-lg-0 pt-lg-2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item ">
                    <Link className="text-nowrap" to="/repair-replacement-application">
                      Service Application Form
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container-xl embed-container p-0">
        <iframe title="Repair Replacement Form" className="px-md-2 px-lg-0 pb-4" src="https://radio-rentals.secure.force.com/" frameBorder="0" allowfullscreen="" style={{ visibility: 'visible', width: '100%', height: '100%', position: 'absolute' }}></iframe>
      </div>
    </Layout>
  )
}

const RefundForm = () => {
  return (
    <Layout>
      <div className="container-xl p-0 d-none d-lg-block">
        <div className="row">
          <div className="col-md-6 col-sm-12 py-3 mx-2">
            <div className="d-block mb-3 mb-lg-0 pt-lg-2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item ">
                    <Link className="text-nowrap" to="/refunds">Refunds</Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container-xl embed-container p-0">
        <iframe title="Refund Application Form" className="px-md-2 px-lg-0 pb-4" src="https://radio-rentals.secure.force.com/casecreate_refund" frameborder="0" allowfullscreen="" style={{ visibility: 'visible', width: '100%', height: '100%', position: 'absolute' }}></iframe>
      </div>
    </Layout>
  )
}

export { RepairReplacementForm, RefundForm }
